import { render, staticRenderFns } from "./SelectPalette.vue?vue&type=template&id=17eaafac&"
import script from "./SelectPalette.vue?vue&type=script&lang=js&"
export * from "./SelectPalette.vue?vue&type=script&lang=js&"
import style0 from "./SelectPalette.vue?vue&type=style&index=0&id=17eaafac&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports